module.exports = __webpack_public_path__ + "img/E - 03.cfb933ab.png";